// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-wrap__content {
  min-height: calc(120vh - 75px);
}
@media (max-width: 576px) {
  .calendar-wrap__content {
    min-height: calc(100vh - 75px);
  }
}
.calendar-wrap__content .banner-coming-soon {
  background-image: none;
}
@media (max-width: 576px) {
  .calendar-wrap__content .banner-coming-soon {
    flex: 1;
    display: flex;
    align-items: center;
  }
}

/* Full-screen background video */
.background-video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -2;
  pointer-events: none;
}

@media (max-width: 576px) {
  .background-video {
    object-position: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/info/info.component.scss"],"names":[],"mappings":"AAOA;EACI,8BAAA;AANJ;AAOI;EAFJ;IAGM,8BAAA;EAJJ;AACF;AAKG;EACI,sBAAA;AAHP;AAKO;EAHJ;IAIS,OAAA;IACA,aAAA;IACA,mBAAA;EAFV;AACF;;AAOA,iCAAA;AACA;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,oBAAA;AAJJ;;AAOA;EASE;IACE,uBAAA;EAZF;AACF","sourcesContent":["@use '../../../assets/styles/colors';\n@use '../../../assets/styles/bootstrap-essentials';\n\n\n// .lyltc{\n  \n// }\n.calendar-wrap__content{\n    min-height: calc(120vh - 75px);\n    @media (max-width: 576px) {\n      min-height: calc(100vh - 75px);\n    }\n   .banner-coming-soon {\n       background-image: none;\n\n       @media (max-width: 576px) {\n            flex: 1;\n            display: flex;\n            align-items: center;\n       }\n        \n   }\n}\n\n/* Full-screen background video */\n.background-video {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    z-index: -2;\n    pointer-events: none;\n}\n\n@media (max-width: 576px) {\n  // .calendar-wrap {\n  //   min-height: 100svh;\n  // }\n\n  // .calendar-wrap__content {\n  //   min-height: 100svh;\n  // }\n\n  .background-video {\n    object-position: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
